module.exports = __webpack_public_path__ + "static/img/icon-evaluate-1.5ee243b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-evaluate-1.jpg
// module id = PYR9
// module chunks = 21